export const CATALOG_THEME_STORAGE_KEY = 'otr-catalog-palette';

export const CATALOG_THEME_PALETTES = [
  {
    id: 'rose',
    label: 'Rose',
    swatch: '#ff66a3',
    vars: {
      '--neo-bg': '#f4efe6',
      '--neo-pink': '#ff66a3',
      '--neo-pink-light': '#fff0f7',
      '--neo-overlay': 'rgba(244, 239, 230, 0.94)',
    },
  },
  {
    id: 'cyan',
    label: 'Cyan',
    swatch: '#00c8f0',
    vars: {
      '--neo-bg': '#e4f4fb',
      '--neo-pink': '#1ac2ff',
      '--neo-pink-light': '#ecfaff',
      '--neo-overlay': 'rgba(228, 244, 251, 0.94)',
    },
  },
  {
    id: 'gris',
    label: 'Gris clair',
    swatch: '#c4c4c4',
    vars: {
      '--neo-bg': '#e8e8e8',
      '--neo-pink': '#b0b0b0',
      '--neo-pink-light': '#f0f0f0',
      '--neo-overlay': 'rgba(232, 232, 232, 0.94)',
    },
  },
  {
    id: 'lavande',
    label: 'Lavande',
    swatch: '#c084fc',
    vars: {
      '--neo-bg': '#efe8f8',
      '--neo-pink': '#c084fc',
      '--neo-pink-light': '#f7f0ff',
      '--neo-overlay': 'rgba(239, 232, 248, 0.94)',
    },
  },
  {
    id: 'mint',
    label: 'Mint',
    swatch: '#4ade80',
    vars: {
      '--neo-bg': '#e6f6ec',
      '--neo-pink': '#4ade80',
      '--neo-pink-light': '#f0fdf4',
      '--neo-overlay': 'rgba(230, 246, 236, 0.94)',
    },
  },
  {
    id: 'corail',
    label: 'Corail',
    swatch: '#fb923c',
    vars: {
      '--neo-bg': '#f8ece4',
      '--neo-pink': '#fb923c',
      '--neo-pink-light': '#fff4eb',
      '--neo-overlay': 'rgba(248, 236, 228, 0.94)',
    },
  },
];

export function readStoredCatalogTheme() {
  try {
    const stored = localStorage.getItem(CATALOG_THEME_STORAGE_KEY);
    if (stored && CATALOG_THEME_PALETTES.some((p) => p.id === stored)) return stored;
  } catch {
    /* ignore */
  }
  return CATALOG_THEME_PALETTES[0].id;
}

export function getCatalogThemePalette(id) {
  return CATALOG_THEME_PALETTES.find((p) => p.id === id) || CATALOG_THEME_PALETTES[0];
}
